export const SIZE_TO_QUANTITY_MAP = {
  SMALL: 5,
  MEDIUM: 30,
  LARGE: 100
};
export const SIZE_TO_LOCATION_MAP = {
  SMALL: 'HUBSPOT_CREDITS_MERCH_CARD_SMALL',
  MEDIUM: 'HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE',
  LARGE: 'HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE'
};